module.exports = __webpack_public_path__ + "src/assets/img/smoke_five.9bb03c16.svg";